import { render, staticRenderFns } from "./aluminium.vue?vue&type=template&id=230341d9"
import script from "./aluminium.vue?vue&type=script&lang=js"
export * from "./aluminium.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports